module.exports = __webpack_public_path__ + "img/天力模头2.86dd1920.jpg";